<template>
  <p>classificationTest.vue</p>
</template>

<script>
export default {
  name: "classificationTest",
};
</script>

<style scoped></style>
